import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CampaignSharePresetService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private presetUrl = this.baseApiUrl + '/api/v1/campaign_share_preset';

  list(campaignId: number) {
    return this.http.get(this.presetUrl, {params: {campaign_id: String(campaignId)}});
  }

  create(payload: any) {
    return this.http.post(this.presetUrl, payload);
  }

  update(id: number, payload: any) {
    return this.http.put(`${this.presetUrl}/${id}`, payload);
  }

  delete(id: number, campaignId: number) {
    return this.http.delete(`${this.presetUrl}/${id}`, {params: {campaign_id: String(campaignId)}});
  }
}
